import { createSlice } from "@reduxjs/toolkit";
import { WithPayload } from "../../common/utils/withPayload";
import { SiteWithCalibration } from "./respyCalibrationManagement.model";

export interface RespyCalibrationManagementState {
	loading: boolean;
	error?: any;
	sitesAndCalibrations: SiteWithCalibration[];
}

export const respyCalibrationManagementState: RespyCalibrationManagementState =
	{
		loading: false,
		error: null,
		sitesAndCalibrations: [],
	};

export const respyCalibrationManagementSlice = createSlice({
	name: "respyCalibrationManagement",
	initialState: respyCalibrationManagementState,
	reducers: {
		loading: (state) => {
			state.loading = true;
			state.error = null;
		},
		success: (state, action: WithPayload<SiteWithCalibration[]>) => {
			state.loading = false;
			state.sitesAndCalibrations = action.payload;
		},
		error: (state, action: WithPayload<any>) => {
			state.loading = false;
			state.error = action.payload;
		},
	},
});
